import Dropdown from '../global/Dropdown';

export default function HierarchyFilterDropdowns({
  filterByOptions,
  locationOptions,
  filterByField,
  locationFilter,
  onFilterByChange,
  onLocationChange,
  locationPlaceholder = 'All Areas',
  rootClassName = 'header-scope-dropdown',
}) {
  return (
    <>
      <div className="filter-dropdown-outer header-dropdown-outer">
        <Dropdown
          options={filterByOptions}
          value={filterByField}
          onChange={onFilterByChange}
          placeholder="Filter By"
          ariaLabel="Filter by"
          rootClassName={rootClassName}
        />
      </div>
      <div className="filter-dropdown-outer header-dropdown-outer">
        <Dropdown
          options={locationOptions}
          value={locationFilter}
          onChange={onLocationChange}
          placeholder={locationPlaceholder}
          ariaLabel={locationPlaceholder}
          rootClassName={rootClassName}
        />
      </div>
    </>
  );
}
